import { colors } from '@ublend-npm/aulaui-next-web/themes/default';

export default {
  header: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  title: {
    fontSize: 14,
    fontWeight: 500,
    color: colors.text,
  },
  content: {
    fontSize: 14,
    color: colors.text,
    marginTop: 14,
    marginBottom: 20,
    width: '100%',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
};
